var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "b-card",
        { attrs: { title: "Tambah Mater Loket" } },
        [
          _c("b-card-text", [
            _c("form", { staticClass: "mt-5" }, [
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Kategori")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("select2", {
                      attrs: {
                        id: "select-poli",
                        options: _vm.all_kategori_options,
                      },
                      on: { change: _vm.getKonfigurasiKuotaPoli },
                      model: {
                        value: _vm.form.kategori,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "kategori", $$v)
                        },
                        expression: "form.kategori",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Nama Loket")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.form.nama,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "nama", $$v)
                        },
                        expression: "form.nama",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c("div", { staticClass: "col-lg-3 text-lg-end pt-2" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { size: "sm", variant: "primary" },
                        on: { click: _vm.createMasterLoket },
                      },
                      [_vm._v("Simpan")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        attrs: { size: "sm", variant: "danger" },
                        on: { click: _vm.cancelAdd },
                      },
                      [_vm._v("Batal")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }